type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconCheckBoxIndeterminate({ color = 'black', width = 22, height = 22 }: Props) {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18" fill={color} xmlns="http://www.w3.org/2000/svg">
            {/* evenodd carves the dash out of the filled square. */}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 9.95H5C4.72 9.95 4.48 9.86 4.3 9.68C4.12 9.49 4.03 9.26 4.03 8.98C4.03 8.69 4.12 8.46 4.3 8.28C4.48 8.09 4.72 8 5 8H13C13.28 8 13.52 8.09 13.7 8.28C13.88 8.46 13.98 8.69 13.98 8.98C13.98 9.26 13.88 9.49 13.7 9.68C13.52 9.86 13.28 9.95 13 9.95ZM2 18C1.45 18 0.98 17.8 0.59 17.41C0.2 17.02 0 16.55 0 16V2C0 1.45 0.2 0.98 0.59 0.59C0.98 0.2 1.45 0 2 0H16C16.55 0 17.02 0.2 17.41 0.59C17.8 0.98 18 1.45 18 2V16C18 16.55 17.8 17.02 17.41 17.41C17.02 17.8 16.55 18 16 18H2Z"
            />
        </svg>
    );
}
